<template>
  <nav>

    <v-tooltip top :disabled="isMobile()">
      <template v-slot:activator="{ on }">

        <a v-on="on"
          href="https://wa.me/5551995035480?text=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim."
          class="link-float-whatsapp" target="_blank">
          <v-icon color="white" class="icon-float-whatsapp">mdi-whatsapp</v-icon>
        </a>
      </template>
      <span>Falar com o representante Agrosim</span>
    </v-tooltip>

    <!-- <v-app> -->
    <v-app-bar color="#74b849" absolute app>
      
      <v-img :src="require('@assets/logo/Logo_SemFundo_semNome_Agrosim_branco.png')" alt="AgroSim" max-width="50"
        class="ml-3" contain />
      <v-img :src="require('@assets/logo/Nome_SemLogo_SemFundo_Agrosim_branco.png')" alt="AgroSim" max-width="120"
        class="mx-3" contain />

      <v-spacer></v-spacer>

      <v-toolbar-items>

        <v-btn text color="white" link :href="getURL('/users/sign_in')">
          Login
          <v-icon right dark>mdi-login</v-icon>
        </v-btn>
      </v-toolbar-items>

    </v-app-bar>

    <v-main>
      <section id="hero">
        <v-row no-gutters>
          <v-img :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            :src="require('@assets/site_images/field_sunrise.jpg')" alt="AgroSim"
            :lazy-src="require('@assets/site_images/field_sunrise_lazy.jpg')">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>

            <v-container fill-height>
              <v-row align="center" class="white--text mx-auto" justify="center" style="width: 100%;">
                <v-col class="white--text text-left" cols="12" tag="h1">
                  <span class="font-weight-light" :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']">
                    Seja bem-vindo
                  </span>

                  <br>

                  <div align="center" justify="center" class="my-5">
                    <v-img :src="require('@assets/logo/Logo_FundoBranco_Agrosim_reduzido.png')" alt="AgroSim"
                      max-width="500" class="" contain />
                  </div>
                </v-col>

                <v-btn class="align-self-end" fab outlined color="white" @click="$vuetify.goTo('#about-me')">
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-img>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">O que é AgroSim?</h2>

          <v-responsive class="mx-auto mb-8" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720">
            Agrosim é uma plataforma que você, produtor rural, precisa para realizar a gestão de sua propriedade de
            forma
            eficiente.
            Com ela você planeja sua safra com antecedência, controla as operações, acompanha custos de cada ciclo, como
            também de toda a safra.
            Além disso, AgroSim faz todo o gerenciamento financeiro e também a gestão dos custos de produção.
            E, ainda, emite a Nota Fiscal Eletrônica do Produtor Rural (NFP-e) e com isto o sistema já alimenta a base
            de
            dados para emissão de relatórios gerenciais.
          </v-responsive>

          <v-row>
            <v-col lg="6" md="8" sm="12" class="mx-auto">

              <!-- DOCUMENTATION: https://avexdesigns.com/blog/responsive-youtube-embed -->
              <div class="video-container">
                <iframe src="https://www.youtube.com/embed/HbCdMtwSH-U?vq=hd1080" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              </div>

            </v-col>
          </v-row>

          <!-- <v-avatar
            class="elevation-12 mb-12"
            size="128"
          >
            <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
          </v-avatar>

          <div></div>

          <v-btn
            color="grey"
            href="https://vuetifyjs.com"
            outlined
            large
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              Vuetify Documentation
            </span>
          </v-btn> -->
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="segment" style="background-color: #002f27 !important;">
        <div class="py-12"></div>

        <span class="text-center">
          <h2 class="display-2 font-weight-bold mb-3 white--text">Segmentos</h2>
        </span>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1 grey lighten-1"></v-divider>

          <v-divider class="grey lighten-1"></v-divider>
        </v-responsive>

        <v-row class="mx-4">
          <v-col lg="3" md="6" sm="12" v-for="segment in segments" :key="segment.title">
            <v-card class="mx-auto" max-width="400" elevation="10" hover shaped>
              <v-img class="white--text align-end" height="200px" :src="require('@assets/site_images/' + segment.image)"
                alt="AgroSim">

              </v-img>

              <v-card-title class="title" style="word-break: break-word; min-height: 100px; display: inline-block">
                {{ segment.title }}
                <v-chip v-if="segment.dev" class="ma-2" color="green" text-color="white" x-small>
                  Em breve
                </v-chip>
              </v-card-title>

              <v-card-text class="text--primary">
                <div style="min-height: 180px;">{{ segment.text }}</div>

              </v-card-text>

            </v-card>
          </v-col>
        </v-row>

        <div class="py-12"></div>
      </section>

      <section id="features" class="grey lighten-3">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Principais Recursos</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4" v-for="({ icon, title, text }, i) in features"
              :key="i">
              <v-card class="py-12 px-4" color="grey lighten-5" flat>
                <!-- <v-theme-provider dark> -->
                <div>
                  <v-avatar color="rgb(134, 207, 229)" size="88">
                    <v-icon large v-text="icon"></v-icon>
                  </v-avatar>
                </div>
                <!-- </v-theme-provider> -->

                <v-card-title class="justify-center font-weight-black text-uppercase" v-text="title"
                  style="word-break: break-word;  min-height: 100px;"></v-card-title>

                <v-card-text class="subtitle-1" v-text="text" style=" min-height: 150px;">
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          :src="require('@assets/site_images/soybean.jpg')" alt="AgroSim">
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col v-for="[value, title] of stats" :key="title" cols="12" md="3">
                <div class="text-center">
                  <div class="display-3 font-weight-black mb-4" v-text="value"></div>

                  <div class="title font-weight-regular text-uppercase" v-text="title"></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <section id="reviews" class="grey lighten-3" v-if="false">

        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Depoimentos de Clientes</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col cols="12">
              <v-carousel cycle interval="20000" min-height="400" width="80%" hide-delimiter-background
                show-arrows-on-hover class="mt-5">
                <v-carousel-item v-for="review in reviews" :key="review.name">
                  <v-sheet height="100%" style="background: #354f56">
                    <v-row class="fill-height">
                      <v-list class="mx-auto" style="background: #354f56">

                        <v-list-item-avatar size="100" class="d-block d-sm-none mx-auto">
                          <v-img :src="require('@assets/site_images/review/' + review.photo)"></v-img>
                        </v-list-item-avatar>

                        <v-list-item>
                          <v-list-item-avatar size="150" class="d-none d-sm-inline-flex">
                            <v-img :src="require('@assets/site_images/review/' + review.photo)"></v-img>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title>
                              <span class="display-1 font-weight-bold">{{ review.name }}</span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <span class="title font-weight-bold">{{ review.details }}</span>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>

                      <v-col cols="12" class=""></v-col>

                      <v-col xs="12" sm="10" md="8" lg="6" class="fill-height mx-auto">
                        <span class="blockquote">
                          "{{ review.review }}"
                        </span>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="photos" class="grey lighten-3" v-if="false">

        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Galeria de Fotos</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>
        </v-container>

        <v-row>
          <v-col cols="12">
            <v-carousel cycle interval="7000" height="350" width="80%" hide-delimiter-background show-arrows-on-hover
              class="mt-5" ref="photosGalleryCarousel" id="galleryCarousel" style="text-align: center;">
              <v-carousel-item v-for="index in getCarouselItems()" :key="index">
                <v-img v-for="photo in getPhotosCarousel(index)" :key="photosGallery[photo].photo"
                  :src="require('@assets/site_images/photos_gallery/' + photosGallery[photo].photo)"
                  class="d-inline-block mx-4" aspect-ratio="1.7778" width="400">
                  <v-row align="end" class="lightbox white--text pa-2 fill-height">
                    <v-col>
                      <v-img :src="require('@assets/logo/Logo_FundoBranco_Agrosim_reduzido.png')" alt="AgroSim"
                        max-width="70" class="d-inline-block float-left mt-8" contain />
                      <div class="d-inline-block float-left mt-10 px-2"
                        style="background: #0000008c; border-radius: 10px;">
                        <span class="title">{{ photosGallery[photo].title }}</span>
                        <br>
                        <span class="subtitle-2 ml-4">{{ photosGallery[photo].subtitle }}</span>
                      </div>
                      
                    </v-col>
                  </v-row>
                </v-img>
              </v-carousel-item>
            </v-carousel>
          </v-col>
        </v-row>
        <!-- </v-container> -->
      </section>

      <section id="mobile_apps">
        <div class="py-12"></div>

        <span class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Baixe o App</h2>
        </span>

        <v-responsive class="mx-auto mb-1" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row style="width: 100%; margin:0px;">
          <v-col lg="6" md="6" sm="12">

            <a href="https://apps.apple.com/br/app/agrosim/id1598344942?l=pt-br#?platform=iphone" target="_blank">
              <v-img :src="require('@assets/site_images/apple_store.png')" alt="App Store" width="200"
                class="float-md-right mr-md-15 mx-auto" />
            </a>

          </v-col>

          <v-col lg="6" md="6" sm="12">

            <a href="https://play.google.com/store/apps/details?id=agrosim.app.com.br.agrosimwebapp" target="_blank">
              <v-img :src="require('@assets/site_images/android_store.png')" alt="Google Play" width="200"
                class="float-md-left ml-md-15 mx-auto" />
            </a>

          </v-col>

        </v-row>

        <div class="py-6"></div>
      </section>

      <section id="team" class="grey lighten-3">
        <div class="py-12"></div>

        <span class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Equipe AgroSim</h2>
        </span>

        <v-responsive class="mx-auto mb-1" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row style="width: 100%; margin:0px;">
          <v-col lg="3" md="6" sm="12" v-for="member in team" :key="member.name">
            <div class="py-3"></div>

            <v-container class="text-center">
              <h3 class="display-1 font-weight-bold mb-3">{{ member.name }}</h3>

              <!-- <v-responsive
                class="mx-auto mb-8"
                width="56"
              >
                <v-divider class="mb-1"></v-divider>

                <v-divider></v-divider>
              </v-responsive> -->

              <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720">
                {{ member.text }}
              </v-responsive>

              <v-avatar class="elevation-12 mb-12" size="128">
                <v-img :src="require('@assets/site_images/team/' + member.photo)" :alt="member.name" />
              </v-avatar>

              <div></div>

              <!-- <v-btn
                color="grey"
                href="https://vuetifyjs.com"
                outlined
                large
              >
                <span class="grey--text text--darken-1 font-weight-bold">
                  Vuetify Documentation
                </span>
              </v-btn> -->
            </v-container>
          </v-col>

        </v-row>

        <div class="py-6"></div>
      </section>


      <section id="partners">

        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">Parceiros</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <!-- DENUTRI -->
            <v-col lg="4" md="4" sm="12" class="mx-auto">

              <div align="center" justify="center" class="my-5">
                <v-img :src="require('@assets/site_images/partner_logos/denutri_logo.png')"
                  alt="Denutri - Soluções em Nutrição Vegetal" max-width="350" class="" contain />

                <p class="mt-4 mb-0 font-weight-bold">Soluções nutricionais, sementes e fitossanitários.</p>
                <p class="mb-2">Dois Irmãos - RS</p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://denutri.com.br/" target="_blank"
                        class="colored-site-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-web</v-icon>
                        <span> denutri.com.br </span>
                      </a>
                    </template>
                    <span>Ir para o site da Denutri</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" target="_blank" class="colored-whatsapp-button partner-social-button"
                        href="https://wa.me/555195035480?text=Ol%C3%A1.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20Denutri.%20Peguei%20este%20contato%20pelo%20site%20do%20AgroSim.%20Poderia%20me%20ajudar%3F">
                        <v-icon class="partner-social-icon">mdi-whatsapp</v-icon>
                        <span> Falar com a Denutri </span>
                      </a>
                    </template>
                    <span>Ir para o WhatsApp da Denutri</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.facebook.com/denutri" target="_blank"
                        class="colored-facebook-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-facebook</v-icon>
                        <span> denutri </span>
                      </a>
                    </template>
                    <span>Ir para o Facebook da Denutri</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.instagram.com/denutri.agro/" target="_blank"
                        class="colored-instagram-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-instagram</v-icon>
                        <span> @denutri.agro </span>
                      </a>
                    </template>
                    <span>Ir para o Instagram da Denutri</span>
                  </v-tooltip>
                </p>
              </div>

            </v-col>

            <!-- PLAGECOR -->
            <!-- <v-col lg="4" md="4" sm="12" class="mx-auto">

              <div align="center" justify="center" class="my-5">
                <v-img :src="require('@assets/site_images/partner_logos/plagecor_logo.png')"
                  alt="Plagecor - Inovação em Gestão Rural" max-width="400" class="" contain />

                <p class="mt-3 mb-0 font-weight-bold">Consultoria de gestão e inovação em proriedades rurais.</p>
                <p class="mb-2">Capivari do Sul - RS</p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" target="_blank" class="colored-whatsapp-button partner-social-button"
                        href="https://wa.me/5551998080156?text=Ol%C3%A1.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20Plagecor.%20Peguei%20este%20contato%20pelo%20site%20do%20AgroSim.%20Poderia%20me%20ajudar%3F">
                        <v-icon class="partner-social-icon">mdi-whatsapp</v-icon>
                        <span>Falar com a Plagecor </span>
                      </a>
                    </template>
                    <span>Ir para o WhatsApp da Plagecor</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.facebook.com/plagecor" target="_blank"
                        class="colored-facebook-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-facebook</v-icon>
                        <span> plagecor </span>
                      </a>
                    </template>
                    <span>Ir para o Facebook da Plagecor</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.instagram.com/plagecor" target="_blank"
                        class="colored-instagram-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-instagram</v-icon>
                        <span> @plagecor </span>
                      </a>
                    </template>
                    <span>Ir para o Instagram da Plagecor</span>
                  </v-tooltip>
                </p>
              </div>

            </v-col> -->

            <!-- BASE FORTE -->
            <!-- <v-col lg="4" md="4" sm="12" class="mx-auto">
              <div align="center" justify="center" class="mt-7 mb-5">
                <v-img :src="require('@assets/site_images/partner_logos/base_forte_logo.png')"
                  alt="Base Forte - Agricultura de Precisão" max-width="400" class="" contain />

                <p class="mt-4 mb-0 font-weight-bold">Consultoria de grãos com foco em Agricultura de Precisão.</p>
                <p class="mb-2">Almirante Tamandaré do Sul - RS</p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.baseforteap.com.br " target="_blank"
                        class="colored-site-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-web</v-icon>
                        <span> baseforteap.com.br </span>
                      </a>
                    </template>
                    <span>Ir para o site da Base Forte</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" target="_blank" class="colored-whatsapp-button partner-social-button"
                        href="https://wa.me/5554991763046?text=Ol%C3%A1.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20Base%20Forte.%20Peguei%20este%20contato%20pelo%20site%20do%20AgroSim.%20Poderia%20me%20ajudar%3F">
                        <v-icon class="partner-social-icon">mdi-whatsapp</v-icon>
                        <span> Falar com a Base Forte </span>
                      </a>
                    </template>
                    <span>Ir para o WhatsApp da Base Forte</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.facebook.com/baseforteap" target="_blank"
                        class="colored-facebook-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-facebook</v-icon>
                        <span> baseforteap </span>
                      </a>
                    </template>
                    <span>Ir para o Facebook da Base Forte</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.instagram.com/baseforteap" target="_blank"
                        class="colored-instagram-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-instagram</v-icon>
                        <span> @baseforteap </span>
                      </a>
                    </template>
                    <span>Ir para o Instagram da Base Forte</span>
                  </v-tooltip>
                </p>
              </div>

            </v-col> -->

            <!-- TMA -->
            <!-- <v-col lg="4" md="6" sm="12" class="mx-auto">
              <div align="center" justify="center" class="mt-7 mb-5">
                <v-img :src="require('@assets/site_images/partner_logos/tma_logo.png')" alt="TMA - Business Company"
                  max-width="400" class="" contain />

                <p class="mt-4 mb-0 font-weight-bold">Business Company.</p>
                <p class="mb-2">Machadinho - RS</p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" target="_blank" class="colored-whatsapp-button partner-social-button"
                        href="https://wa.me/555484030509?text=Ol%C3%A1.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20TMA.%20Peguei%20este%20contato%20pelo%20site%20do%20AgroSim.%20Poderia%20me%20ajudar%3F">
                        <v-icon class="partner-social-icon">mdi-whatsapp</v-icon>
                        <span> Falar com a TMA </span>
                      </a>
                    </template>
                    <span>Ir para o WhatsApp da TMA</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.facebook.com/TMA-Business-Company-104840695449743" target="_blank"
                        class="colored-facebook-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-facebook</v-icon>
                        <span> TMA Business Company </span>
                      </a>
                    </template>
                    <span>Ir para o Facebook da TMA</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="https://www.instagram.com/tma_business_company" target="_blank"
                        class="colored-instagram-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-instagram</v-icon>
                        <span> @tma_business_company </span>
                      </a>
                    </template>
                    <span>Ir para o Instagram da TMA</span>
                  </v-tooltip>
                </p>
              </div>

            </v-col> -->


            <!-- PGD -->
            <!-- <v-col lg="4" md="6" sm="12" class="mx-auto">
              <div align="center" justify="center" class="mt-7 mb-5">
                <v-img :src="require('@assets/site_images/partner_logos/pgd_logo.png')" alt="PGD - Engenharia Rural"
                  max-width="300" class="" contain />
                <p class="mt-4 mb-0 font-weight-bold">Engenharia Rural.</p>
                <p class="mb-2">Camaquã - RS</p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" href="http://www.pgdengenharia.com.br/" target="_blank"
                        class="colored-site-button partner-social-button">
                        <v-icon class="partner-social-icon">mdi-web</v-icon>
                        <span> pgdengenharia.com.br </span>
                      </a>
                    </template>
                    <span>Ir para o site da PGD</span>
                  </v-tooltip>
                </p>
                <p class="mb-1">
                  <v-tooltip top :disabled="isMobile()">
                    <template v-slot:activator="{ on }">
                      <a v-on="on" target="_blank" class="colored-whatsapp-button partner-social-button"
                        href="https://wa.me/555199715134?text=Ol%C3%A1.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20PGD.%20Peguei%20este%20contato%20pelo%20site%20do%20AgroSim.%20Poderia%20me%20ajudar%3F">
                        <v-icon class="partner-social-icon">mdi-whatsapp</v-icon>
                        <span> Falar com a PGD </span>
                      </a>
                    </template>
                    <span>Ir para o WhatsApp da PGD</span>
                  </v-tooltip>
                </p>
              </div>
            </v-col> -->


          </v-row>

          <!-- <v-row> -->
          <!-- <v-col lg="8" md="10" sm="12" class="mx-auto"> -->
          <!-- DOCUMENTATION:  https://core-player.github.io/vue-core-video-player/configuration.html -->
          <!-- :autoplay="false" -->
          <!-- <vue-core-video-player
                :autoplay="false"
                src="https://youtu.be/hEqBhsQytII"
              ></vue-core-video-player> -->
          <!-- <video controls autoplay>
                <source src="https://drive.google.com/uc?export=download&id=1sizokqU0x3_0AP8tQSnoY-EdWCE1hJHp" type="video/mp4">
                Your browser does not support the video tag.
              </video> -->
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-container>
      </section>

      <!-- <section id="blog" v-if="false">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Blog</h2>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ src, text, title }, i) in articles"
              :key="i"
              cols="12"
              md="4"
            >
              <v-img
                :src="src"
                class="mb-4"
                height="275"
                max-width="100%"
              ></v-img>

              <h3
                class="font-weight-black mb-4 text-uppercase"
                v-text="title"
              ></h3>

              <div
                class="title font-weight-light mb-5"
                v-text="text"
              ></div>

              <v-btn
                class="ml-n4 font-weight-black"
                text
              >
                Continue Reading
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section> -->



      <v-sheet id="contact" color="#333333" dark tag="section" tile>
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Contatos e Redes Sociais</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <!-- <v-col sm="12" class="d-sm-none">
              <v-list-item-avatar size="100">
                <v-img :src="require('@assets/site_images/team/daniel.jpg')"></v-img>
              </v-list-item-avatar>
            </v-col> -->

            <v-col xs="12" sm="10" md="8" lg="6" xl="4" class="mx-auto">
              <v-list three-line>

                <!-- <v-divider
                  v-else-if="item.divider"
                  :key="index"
                  :inset="item.inset"
                ></v-divider> -->

                <div class="d-blobk d-sm-none mx-auto py-3">
                  <v-list-item-avatar size="100" class="d-block d-sm-none mx-auto">
                    <v-img :src="require('@assets/site_images/team/daniel.jpg')"></v-img>
                  </v-list-item-avatar>

                  <div class="mx-3">
                    <span class="display-1 font-weight-bold">Daniel Hentz</span>
                    <br>
                    <span class="body-1 ml-3">(Comercial)</span>
                    <br>
                    <br>
                    <span class="title font-weight-bold">Whats e Fone:</span>
                    <br>
                    <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-on="on" class="title ml-3" style="text-decoration: none;" href="tel:+5551995035480">(51)
                          99503-5480</a>
                      </template>
                      <span>Ligar para o Daniel Hentz da AgroSim</span>
                    </v-tooltip>

                    <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-on="on" class="title ml-3" style="text-decoration: none;"
                          href="https://wa.me/5551995035480?text=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                          <v-icon color="#25D366">mdi-whatsapp</v-icon>
                        </a>
                      </template>
                      <span>Enviar um WhatsApp para o Daniel Hentz da AgroSim</span>
                    </v-tooltip>

                    <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-if="isApple()" v-on="on" class="title ml-3" style="text-decoration: none;"
                          href="sms:+5551995035480&body=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                          <v-icon color="blue">mdi-message-processing</v-icon>
                        </a>
                        <a v-else v-on="on" class="title ml-3" style="text-decoration: none;"
                          href="sms:+5551995035480?body=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                          <v-icon color="blue">mdi-message-processing</v-icon>
                        </a>
                      </template>
                      <span>Enviar um SMS para o Daniel Hentz da AgroSim</span>
                    </v-tooltip>
                    <br>
                    <span class="title font-weight-bold">E-mail: </span>
                    <br>
                    <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-on="on" class="title ml-3" style="text-decoration: none;"
                          href="mailto:daniel@agrosim.com.br?subject=Contato%20AgroSim&body=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                          daniel@agrosim.com.br
                        </a>
                      </template>
                      <span>Enviar um e-mail para o Daniel Hentz da AgroSim</span>
                    </v-tooltip>
                  </div>
                </div>

                <v-list-item class="d-none d-sm-flex">
                  <v-list-item-avatar size="100">
                    <v-img :src="require('@assets/site_images/team/daniel.jpg')"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="display-1 font-weight-bold">Daniel Hentz</span>
                      <span class="body-1 ml-3">(Comercial)</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="title font-weight-bold">Fone:</span>
                      <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-on="on" class="title ml-3" style="text-decoration: none;" href="tel:+5551995035480">(51)
                            99503-5480</a>
                        </template>
                        <span>Ligar para o Daniel Hentz da AgroSim</span>
                      </v-tooltip>

                      <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-on="on" class="title ml-3" style="text-decoration: none;" target="_blank"
                            href="https://wa.me/5551995035480?text=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                            <v-icon color="#25D366">mdi-whatsapp</v-icon>
                          </a>
                        </template>
                        <span>Enviar um WhatsApp para o Daniel Hentz da AgroSim</span>
                      </v-tooltip>

                      <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-if="isApple()" v-on="on" class="title ml-3" style="text-decoration: none;"
                            href="sms:+5551995035480&body=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                            <v-icon color="blue">mdi-message-processing</v-icon>
                          </a>
                          <a v-else v-on="on" class="title ml-3" style="text-decoration: none;"
                            href="sms:+5551995035480?body=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                            <v-icon color="blue">mdi-message-processing</v-icon>
                          </a>
                        </template>
                        <span>Enviar um SMS para o Daniel Hentz da AgroSim</span>
                      </v-tooltip>

                      <br>
                      <span class="title font-weight-bold">E-mail: </span>
                      <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-on="on" class="title ml-3" style="text-decoration: none;"
                            href="mailto:daniel@agrosim.com.br?subject=Contato%20AgroSim&body=Ol%C3%A1%2C%20Daniel.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                            daniel@agrosim.com.br
                          </a>
                        </template>
                        <span>Enviar um e-mail para o Daniel Hentz da AgroSim</span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>

            <v-col xs="12" sm="10" md="8" lg="6" xl="4" class="mx-auto">
              <v-list three-line>

                <!-- <v-divider
                  v-else-if="item.divider"
                  :key="index"
                  :inset="item.inset"
                ></v-divider> -->

                <div class="d-blobk d-sm-none mx-auto py-3">
                  <v-list-item-avatar size="100" class="d-block d-sm-none mx-auto">
                    <v-img :src="require('@assets/site_images/team/suporte.png')"></v-img>
                  </v-list-item-avatar>

                  <div class="mx-3">
                    <span class="display-1 font-weight-bold">AgroSim</span>
                    <br>
                    <!-- <span class="body-1 ml-3">(Ajuda Técnica)</span> -->
                    <!-- <br> -->
                    <!-- <br> -->
                    <!-- <span class="title font-weight-bold">Whats e Fone:</span>
                    <br> -->
                    <!-- <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-on="on" class="title ml-3" style="text-decoration: none;" href="tel:+5551980629669">(51) 98062-9669</a>
                      </template>
                      <span>Ligar para o Suporte Técnico da AgroSim</span>
                    </v-tooltip>
                    
                    <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-on="on" class="title ml-3" style="text-decoration: none;" href="https://wa.me/5551980629669?text=Ol%C3%A1%2C%20Suporte%20T%C3%A9cnico.%20Gostaria%20de%20obter%20ajuda%20t%C3%A9cnica%20sobre%20a%20plataforma%20AgroSim.">
                          <v-icon color="green">mdi-whatsapp</v-icon>
                        </a>
                      </template>
                      <span>Enviar um WhatsApp para o Suporte Técnico da AgroSim</span>
                    </v-tooltip>

                    <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-if="isApple()" v-on="on" class="title ml-3" style="text-decoration: none;" href="sms:+5551980629669&body=Ol%C3%A1%2C%20Suporte%20T%C3%A9cnico.%20Gostaria%20de%20obter%20ajuda%20t%C3%A9cnica%20sobre%20a%20plataforma%20AgroSim.">
                          <v-icon color="blue">mdi-message-processing</v-icon>
                        </a>
                        <a v-else v-on="on" class="title ml-3" style="text-decoration: none;" href="sms:+5551980629669?body=Ol%C3%A1%2C%20Suporte%20T%C3%A9cnico.%20Gostaria%20de%20obter%20ajuda%20t%C3%A9cnica%20sobre%20a%20plataforma%20AgroSim.">
                          <v-icon color="blue">mdi-message-processing</v-icon>
                        </a>
                      </template>
                      <span>Enviar um SMS para o Suporte Técnico da AgroSim</span>
                    </v-tooltip> -->
                    <br>
                    <span class="title font-weight-bold">E-mail: </span>
                    <br>
                    <v-tooltip bottom :disabled="isMobile()">
                      <template v-slot:activator="{ on }">
                        <a v-on="on" class="title ml-3" style="text-decoration: none;"
                          href="mailto:contato@agrosim.com.br?subject=Contato%20equipe%20AgroSim&body=Ol%C3%A1%2C%20AgroSim.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                          contato@agrosim.com.br
                        </a>
                      </template>
                      <span>Enviar um e-mail para o AgroSim</span>
                    </v-tooltip>
                  </div>
                </div>

                <v-list-item class="d-none d-sm-flex">
                  <v-list-item-avatar size="100">
                    <v-img :src="require('@assets/site_images/team/suporte.png')"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="display-1 font-weight-bold">AgroSim</span>
                      <!-- <span class="body-1 ml-3">(Ajuda Técnica)</span> -->
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <!-- <span class="title font-weight-bold">Fone:</span> -->

                      <!-- <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-on="on" class="title ml-3" style="text-decoration: none;" href="tel:+5551980629669">(51) 98062-9669</a>
                        </template>
                        <span>Ligar para o Suporte Técnico da AgroSim</span>
                      </v-tooltip>
                      
                      <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-on="on" class="title ml-3" style="text-decoration: none;" href="https://wa.me/5551980629669?text=Ol%C3%A1%2C%20Suporte%20T%C3%A9cnico.%20Gostaria%20de%20obter%20ajuda%20t%C3%A9cnica%20sobre%20a%20plataforma%20AgroSim.">
                            <v-icon color="green">mdi-whatsapp</v-icon>
                          </a>
                        </template>
                        <span>Enviar um WhatsApp para o Suporte Técnico da AgroSim</span>
                      </v-tooltip>

                      <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-if="isApple()" v-on="on" class="title ml-3" style="text-decoration: none;" href="sms:+5551980629669&body=Ol%C3%A1%2C%20Suporte%20T%C3%A9cnico.%20Gostaria%20de%20obter%20ajuda%20t%C3%A9cnica%20sobre%20a%20plataforma%20AgroSim.">
                            <v-icon color="blue">mdi-message-processing</v-icon>
                          </a>
                          <a v-else v-on="on" class="title ml-3" style="text-decoration: none;" href="sms:+5551980629669?body=Ol%C3%A1%2C%20Suporte%20T%C3%A9cnico.%20Gostaria%20de%20obter%20ajuda%20t%C3%A9cnica%20sobre%20a%20plataforma%20AgroSim.">
                            <v-icon color="blue">mdi-message-processing</v-icon>
                          </a>
                        </template>
                        <span>Enviar um SMS para o Suporte Técnico da AgroSim</span>
                      </v-tooltip> -->
                      <!-- <br> -->
                      <span class="title font-weight-bold">E-mail: </span>
                      <v-tooltip bottom :disabled="isMobile()">
                        <template v-slot:activator="{ on }">
                          <a v-on="on" class="title ml-3" style="text-decoration: none;"
                            href="mailto:contato@agrosim.com.br?subject=Contato%20equipe%20AgroSim&body=Ol%C3%A1%2C%20AgroSim.%20Gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20plataforma%20AgroSim.">
                            contato@agrosim.com.br
                          </a>
                        </template>
                        <span>Enviar um e-mail para a equipe do AgroSim</span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
          </v-row>

          <v-row>

            <ul class="footer-social">
              <v-divider style="margin-right: 30px;" />

              <li>
                <v-tooltip top :disabled="isMobile()">
                  <template v-slot:activator="{ on }">
                    <a v-on="on" href="https://www.facebook.com/agrosimapp" target="_blank"
                      class="facebook-button footer-social-button">
                      <v-icon class="footer-social-icon">mdi-facebook</v-icon>
                    </a>
                  </template>
                  <span>Facebook</span>
                </v-tooltip>
              </li>
              <li>
                <v-tooltip top :disabled="isMobile()">
                  <template v-slot:activator="{ on }">
                    <a v-on="on" href="https://www.instagram.com/agrosim_app" target="_blank"
                      class="instagram-button footer-social-button">
                      <v-icon class="footer-social-icon">mdi-instagram</v-icon>
                    </a>
                  </template>
                  <span>Instagram</span>
                </v-tooltip>
              </li>
              <li>
                <v-tooltip top :disabled="isMobile()">
                  <template v-slot:activator="{ on }">
                    <a v-on="on" href="https://www.youtube.com/channel/UCTt6D42agNkYKu-QU5Ueamw" target="_blank"
                      class="youtube-button footer-social-button">
                      <v-icon class="footer-social-icon">mdi-youtube</v-icon>
                    </a>
                  </template>
                  <span>YouTube</span>
                </v-tooltip>
              </li>
              <li>
                <v-tooltip top :disabled="isMobile()">
                  <template v-slot:activator="{ on }">
                    <a v-on="on" href="https://www.linkedin.com/company/agrosimapp" target="_blank"
                      class="linkedin-button footer-social-button">
                      <v-icon class="footer-social-icon">mdi-linkedin</v-icon>
                    </a>
                  </template>
                  <span>LinkedIn</span>
                </v-tooltip>
              </li>
              <v-divider />
            </ul>
          </v-row>

          <!-- <v-theme-provider light> -->
          <!-- Form to contact from the website -->
          <!-- <v-row>
              <v-col cols="12">
                <v-text-field
                  flat
                  label="Name*"
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  flat
                  label="Email*"
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  flat
                  label="Subject*"
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  flat
                  label="Message*"
                  solo
                ></v-textarea>
              </v-col>

              <v-col
                class="mx-auto"
                cols="auto"
              >
                <v-btn
                  color="accent"
                  x-large
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row> -->
          <!-- </v-theme-provider> -->
        </v-container>

        <div class="py-4"></div>
      </v-sheet>
    </v-main>

    <v-footer class="justify-center" color="#292929" height="100">
      <v-row align="center" justify="center">

        <a href="/privacy_policy" class="col-12 text-center">
          Política de Privacidade
        </a>
        <div class="title font-weight-light grey--text text--lighten-1 text-center">
          &copy; {{ (new Date()).getFullYear() }} — Equipe AgroSim — Feito com 💚 para nossos clientes
        </div>
      </v-row>
    </v-footer>
    <!-- </v-app> -->
  </nav>
</template>

<script>

export default {
  name: 'WebSite',
  data() {
    return {
      articles: [
        {
          src: 'https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80',
          title: 'Mobile first & Responsive',
          text: 'Phasellus lorem enim, luctus ut velit eget, convallis egestas eros. Sed ornare ligula eget tortor tempor, quis porta tellus dictum.',
        },
        {
          src: 'https://images.unsplash.com/photo-1475938476802-32a7e851dad1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80',
          title: 'Think outside the box',
          text: 'Nam ut leo ipsum. Maecenas pretium aliquam feugiat. Aenean vel tempor est, vitae tincidunt risus. Sed sodales vestibulum nibh.',
        },
        {
          src: 'https://images.unsplash.com/photo-1416339442236-8ceb164046f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1892&q=80',
          title: 'Small changes, big difference',
          text: 'Vestibulum in dictum velit, in rhoncus nibh. Maecenas neque libero, interdum a dignissim in, aliquet vitae lectus. Phasellus lorem enim, luctus ut velit eget.',
        },
      ],
      segments: [
        {
          title: "Produtor de Cereais",
          text: "Atende de forma específica todo o processo de produção de cereais, incluindo operações, atividades realizadas, itens consumidos etc.",
          image: "rice.jpg",
          dev: false
        },
        {
          title: "Viveiro de Hortaliças",
          text: "Atende de forma específica todo o processo de produção, gerando os lotes de produção para atender a legislação.",
          image: "greenery.jpg",
          dev: true
        },
        {
          title: "Produtor de hortaliças, frutas e verduras",
          text: "A plataforma contempla este segmento com a rastreabilidade, geração do caderno de campo, emissão de NFP-e para atender a legislação vigente etc.",
          image: "vegetables.jpg",
          dev: true
        },
        {
          title: "Produtor de Sementes de Cereais",
          text: "A plataforma gera os lotes de produção de sementes para que o sementeiro possa fazer a rastreabilidade de todos os campos de produção de sementes, contemplando assim o talhão em que cada lote foi produzido. Além de todas as funcionalidades como controle financeiro, operações de lavoura, emissão de NFP-e etc.",
          image: "seeds.jpg",
          dev: true
        },
      ],
      features: [
        {
          icon: 'mdi-arrow-decision',
          title: 'Tomada de decisões',
          text: 'Oferece informações claras, possibilitando a tomadas de decisões para cada situação e área da fazenda.',
        },
        {
          icon: 'mdi-update',
          title: 'Histórico de dados',
          text: 'Gera um banco de dados de todos os processos da fazenda, como por exemplo a aquisição de insumos, fornecedores, quantidades, preços etc.',
        },
        {
          icon: 'mdi-clipboard-flow',
          title: 'Organização dos processos',
          text: 'Mantém um histórico também das atividades a serem desenvolvidas, já previamente planejadas para diminuir custos de produção.',
        },
        {
          icon: 'mdi-sprout',
          title: 'Base de itens/produtos compartilhados',
          text: 'Possui uma base de dados previamente cadastrada de agrotóxicos, sementes, fertilizantes e biológicos. Também conta com culturas, produtos colhidos, variedades de sementes, mudas de hortaliças.',
        },
        {
          icon: 'mdi-airplane-takeoff',
          title: 'Planejamento de Ciclos e Safras',
          text: 'O produtor faz todo o planejamento da próxima safra com antecedência e, assim, pode analisar onde estão os fatores limitantes de sua operação, seja disponibilidade de recursos, necessidades de insumos, entre outros.',
        },
        {
          icon: 'mdi-file-certificate-outline',
          title: 'Documentos Fiscais',
          text: 'O sistema conta com a emissão de Nota Fiscal do Produtor eletrônica (NFP-e) para atender a legislação vigente. Também conta com um sistema automatizado que sugere toda a parte de tributação para cada item da nota fiscal.',
        },
      ],
      stats: [
        ['21', 'Fazendas gerenciadas'],
        // ['+2,6 mil', 'Hectares controlados'],
        ['3', 'Estados do Brasil atuantes'],
        ['+7 mil', 'Itens e produtos cadastrados'],
        ['4', 'Segmentos contemplados']
      ],
      team: [
        {
          name: "Daniel Hentz",
          text: "Nascido e criado no meio rural, formou-se técnico em agropecuária e sempre exerceu a atividade atuando em várias regiões do país." +
            "Mais tarde, começou a empreender, primeiro na área de comércio de insumos agrícolas. " +
            "Depois, dedicou parte do tempo em formação acadêmica, na qual se formou Bacharel em Administração." +
            "Também concluiu vários outros cursos de especialização na área técnica. " +
            "Trabalhando em fazendas, desenvolveu expertise em fluxo de processos e administração de propriedades rurais." +
            "Posteriormente, consolidou a parceria com especialistas em TI para o desenvolvimento da plataforma AgroSim.",
          photo: "daniel.jpg"
        },
        {
          name: "Felipe de Morais",
          text: "Técnico em informática, bacharel em Ciência da Computação com período de intercâmbio nos Estados Unidos, onde morou e estudou durante um ano e meio. " +
            "Mestre em computação aplicada e atualmente doutorando em Computação Aplicada na Unisinos - RS. " +
            "Sua área de estudo desde o mestrado tem sido em Inteligência Artificial e ciência de dados, incluindo mineração de dados e descoberta de conhecimento em bases de dados. " +
            "Tem experiência em desenvolvimento de software em sistemas de gestão e atualmente faz parte do time de desenvolvimento e planejamento da plataforma AgroSim.",
          photo: "felipe.jpg"
        },
        {
          name: "Thiago Konrad",
          text: "Bacharel em Ciência da Computação pela Unisinos, fez parte do projeto SIMTUR onde realizou pesquisas acadêmicas na área de sistemas inteligentes de transporte. " +
            "Como autônomo, obteve experiência em análise e desenvolvimento de aplicações web e mobile. " +
            "Posteriormente, trabalhou na criação de soluções envolvendo marketing de proximidade móvel, geolocalização e Beacons. " +
            "Atualmente atua, com muito orgulho, como um dos principais engenheiros de software por trás da plataforma AgroSim.",
          photo: "thiago.jpg"
        },
        {
          name: "Tiago Sommer",
          text: "Formado em Ciência da Computação pela Unisinos. Colaborou com o desenvolvimento de novas tecnologias no meio acadêmico, no qual realizou o mestrado em Computação Aplicada. " +
            "Tem experiência no desenvolvimento de aplicações para smartphone e em serviços da web. " +
            "Trabalha como desenvolvedor mobile, no qual utiliza tecnologias recentes com uso de NFC. " +
            "Atualmente, tem muito orgulho de fazer parte do time de planejamento e desenvolvimento da plataforma AgroSim.",
          photo: "tiago.png"
        },
      ],
      reviews: [
        {
          name: "Meu guri gripado",
          details: "Fazenda AgroSim",
          review: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam aspernatur, sint recusandae cum temporibus quos saepe repellendus consectetur et reprehenderit. Ratione ipsam consequuntur quo eligendi mollitia veniam facere possimus inventore.",
          photo: "thiago.jpg"
        },
        {
          name: "Fulano de Tal 2",
          details: "Fazenda FZD",
          review: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam aspernatur, sint recusandae cum temporibus quos saepe repellendus consectetur et reprehenderit. Ratione ipsam consequuntur quo eligendi mollitia veniam facere possimus inventore.",
          photo: "thiago.jpg"
        },
      ],
      photosGallery: [
        {
          photo: "photo1.jpg",
          title: "Foto 1",
          subtitle: "Fazenda 1",
        },
        {
          photo: "photo2.jpg",
          title: "Foto 2",
          subtitle: "Fazenda 3",
        },
        {
          photo: "photo3.jpg",
          title: "Foto 3",
          subtitle: "Fazenda 3",
        },
        {
          photo: "photo4.jpg",
          title: "Foto 4",
          subtitle: "Fazenda 4",
        },
        {
          photo: "photo5.jpg",
          title: "Foto 5",
          subtitle: "Fazenda 5",
        },
      ]
    }
  },
  components: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    getURL(page) {
      return window.location.protocol + "//" + window.location.host + page;
    },
    getCarouselItems() {
      let limit = (window.innerWidth * 0.9) / 500;
      limit = Math.round(limit, 0);
      let array = [];
      let range = Math.ceil(this.photosGallery.length / limit);
      for (let i = 0; i < range; i++) {
        array.push(i);
      }
      return array;
    },
    getPhotosCarousel(carouselIndex) {
      let limit = (window.innerWidth * 0.9) / 500;
      limit = Math.round(limit, 0);
      let array = [];
      for (let i = carouselIndex * limit; i < (carouselIndex * limit + limit); i++) {
        if (i < this.photosGallery.length) {
          array.push(i);
        }
      }
      return array;
    },
    isAndroid() {
      if (/Android/i.test(navigator.userAgent)) {
        return true
      }
      return false
    },
    isApple() {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      }
      return false
    },
  }
}

</script>

<style>
.video-container {
  position: relative;
  padding-bottom: 50%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 95%;
  height: 100%;
}

.link-float-whatsapp {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25D366;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
  text-decoration: none;
}

.icon-float-whatsapp {
  font-size: 35px !important;
  margin-top: 11px;
}

.footer-social {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  margin-top: 30px;
  list-style: none;
  padding-left: 0px;
}

.footer-social-button {
  text-decoration: none;
  margin-right: 30px;
}

.partner-social-button {
  text-decoration: none;
  margin-right: 30px;
  vertical-align: middle;
}

.partner-social-icon {
  font-size: 25px !important;
}

.footer-social-icon {
  font-size: 35px !important;
}

.footer-social-button .footer-social-icon {
  color: whitesmoke;
}

.colored-whatsapp-button .partner-social-icon {
  color: #25D366 !important;
}

.colored-site-button .partner-social-icon {
  color: #2491eb !important;
}

.facebook-button .footer-social-icon:hover,
.colored-facebook-button .partner-social-icon {
  color: #3b5999 !important;
}

.instagram-button .footer-social-icon:hover,
.colored-instagram-button .partner-social-icon {
  color: #e4405f !important;
}

.youtube-button .footer-social-icon:hover,
.colored-youtube-button .partner-social-icon {
  color: #cd201f !important;
}

.linkedin-button .footer-social-icon:hover,
.colored-linkedin-button .partner-social-icon {
  color: #0077B5 !important;
}
</style>
